
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"41","height":"41","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M31.113 21.92A9 9 0 1018.385 9.192 9 9 0 0031.113 21.92zm1.414-14.142c4.296 4.296 4.296 11.26 0 15.556-4.058 4.058-10.496 4.283-14.818.676l-9.224 9.224-1.414-1.414 9.224-9.224c-3.607-4.322-3.382-10.76.675-14.818 4.296-4.296 11.261-4.296 15.557 0z","fill":"#F2F0EC"}})])
          )
        }
      }
    